/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to revert a bundle sync change (by history row or by batch)
 * @export
 * @interface RevertBundleSyncRequest
 */
export interface RevertBundleSyncRequest {
    /**
     * Revert a single history row by ID
     * @type {string}
     * @memberof RevertBundleSyncRequest
     */
    historyId?: string;
    /**
     * Revert all changes in a batch (order: most recent first so logical undo)
     * @type {string}
     * @memberof RevertBundleSyncRequest
     */
    batchId?: string;
}

/**
 * Check if a given object implements the RevertBundleSyncRequest interface.
 */
export function instanceOfRevertBundleSyncRequest(value: object): value is RevertBundleSyncRequest {
    return true;
}

export function RevertBundleSyncRequestFromJSON(json: any): RevertBundleSyncRequest {
    return RevertBundleSyncRequestFromJSONTyped(json, false);
}

export function RevertBundleSyncRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevertBundleSyncRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'historyId': json['historyId'] == null ? undefined : json['historyId'],
        'batchId': json['batchId'] == null ? undefined : json['batchId'],
    };
}

export function RevertBundleSyncRequestToJSON(json: any): RevertBundleSyncRequest {
    return RevertBundleSyncRequestToJSONTyped(json, false);
}

export function RevertBundleSyncRequestToJSONTyped(value?: RevertBundleSyncRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'historyId': value['historyId'],
        'batchId': value['batchId'],
    };
}

